import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { YodaColors, YodaFontSize, YodaJustifyContent } from '../../yodaTheme';

type DateTimeDisplayProps = {
  date?: string | null;
  time?: string | null;
};

const DateTimeDisplay: FC<DateTimeDisplayProps> = ({ date, time }) => {
  return (
    <Box
      sx={
        {
          width: '100%',
          display: 'flex',
          alignItems: YodaJustifyContent.center,
          gap: '10px',
          fontSize: YodaFontSize.small,
          color: YodaColors.textPrimary,
        }
      }
    >
      <Box display="flex" alignItems="center" gap="6px" width='110px'>
        <CalendarTodayIcon sx={ { fontSize: 16, color: YodaColors.textSecondary } } />
        <Typography fontSize={ YodaFontSize.small }>
          { date ?? '—' }
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" gap="6px">
        <AccessTimeIcon sx={ { fontSize: 16, color: YodaColors.textSecondary } } />
        <Typography fontSize={ YodaFontSize.small }>
          { time ?? '—' }
        </Typography>
      </Box>
    </Box>
  );
};

export default DateTimeDisplay;
